(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('js-cookie')) :
    typeof define === 'function' && define.amd ? define(['exports', 'js-cookie'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.csr = {}, global.Cookies));
})(this, (function (exports, Cookies) { 'use strict';

    let ready = false;
    const isReady = () => {
        return new Promise((resolve, reject) => {
            if (typeof window === "undefined") {
                reject(Error("Missing window, can only be used client-side"));
            }
            if (ready) {
                resolve(true);
            }
            const sendAppReadyMessage = () => {
                window.postMessage({ source: "decoratorClient", event: "ready" }, window.location.origin);
            };
            // Send ready message until decorator responds
            (function wait() {
                if (!ready) {
                    setTimeout(wait, 50);
                    sendAppReadyMessage();
                }
            })();
            const receiveMessage = (msg) => {
                const { data } = msg;
                const isSafe = msgSafetyCheck(msg);
                const { source, event } = data;
                if (isSafe) {
                    if (source === "decorator" && event === "ready") {
                        ready = true;
                        window.removeEventListener("message", receiveMessage);
                        resolve(true);
                    }
                }
            };
            window.addEventListener("message", receiveMessage);
        });
    };
    const msgSafetyCheck = (message) => {
        const { origin, source } = message;
        // Only allow messages from own window
        return window.location.href.indexOf(origin) === 0 && source === window;
    };

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise, SuppressedError, Symbol, Iterator */


    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
        var e = new Error(message);
        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
    };

    const setParams = (params) => isReady()
        .then(() => window.postMessage({
        source: "decoratorClient",
        event: "params",
        payload: params
            ? Object.entries(params).reduce((acc, [key, value]) => value !== undefined
                ? Object.assign(Object.assign({}, acc), { [key]: value }) : acc, {})
            : {},
    }, window.location.origin))
        .catch((error) => console.warn(error));
    const getParams = () => __awaiter(void 0, void 0, void 0, function* () {
        return isReady()
            .then(() => window.__DECORATOR_DATA__.params)
            .catch((error) => {
            console.warn(error);
        });
    });

    const onBreadcrumbClick = (() => {
        let callback;
        const receiveMessage = (msg) => {
            const { data } = msg;
            const isSafe = msgSafetyCheck(msg);
            const { source, event, payload } = data;
            if (isSafe) {
                if (source === "decorator" &&
                    event === "breadcrumbClick" &&
                    callback) {
                    callback(payload);
                }
            }
        };
        if (typeof window !== "undefined") {
            window.addEventListener("message", receiveMessage);
        }
        return (_callback) => {
            callback = _callback;
        };
    })();
    const setBreadcrumbs = (breadcrumbs) => setParams({ breadcrumbs });

    const onLanguageSelect = (() => {
        let callback;
        const receiveMessage = (msg) => {
            const { data } = msg;
            const isSafe = msgSafetyCheck(msg);
            const { source, event, payload } = data;
            if (isSafe) {
                if (source === "decorator" &&
                    event === "languageSelect" &&
                    callback) {
                    callback(payload);
                }
            }
        };
        if (typeof window !== "undefined") {
            window.addEventListener("message", receiveMessage);
        }
        return (_callback) => {
            callback = _callback;
        };
    })();
    const setAvailableLanguages = (availableLanguages) => setParams({ availableLanguages });

    const externalUrls = {
        prod: "https://www.nav.no/dekoratoren",
        dev: "https://dekoratoren.ekstern.dev.nav.no",
        beta: "https://dekoratoren-beta.intern.dev.nav.no",
        betaTms: "https://dekoratoren-beta-tms.intern.dev.nav.no",
    };
    const serviceUrls = {
        prod: "http://nav-dekoratoren.personbruker",
        dev: "http://nav-dekoratoren.personbruker",
        beta: "http://nav-dekoratoren-beta.personbruker",
        betaTms: "http://nav-dekoratoren-beta-tms.personbruker",
    };
    const naisGcpClusters = new Set(["dev-gcp", "prod-gcp"]);
    const objectToQueryString = (params) => params
        ? Object.entries(params).reduce((acc, [k, v], i) => v !== undefined
            ? `${acc}${i ? "&" : "?"}${k}=${encodeURIComponent(typeof v === "object" ? JSON.stringify(v) : v)}`
            : acc, "")
        : "";
    const isNaisApp = () => typeof process !== "undefined" &&
        process.env.NAIS_CLUSTER_NAME &&
        naisGcpClusters.has(process.env.NAIS_CLUSTER_NAME);
    const getNaisUrl = (env, csr = false, serviceDiscovery = true) => {
        const shouldUseServiceDiscovery = serviceDiscovery && !csr && isNaisApp();
        return ((shouldUseServiceDiscovery ? serviceUrls[env] : externalUrls[env]) ||
            externalUrls.prod);
    };
    const getDecoratorBaseUrl = (props) => {
        return props.env === "localhost"
            ? props.localUrl
            : getNaisUrl(props.env, props.csr, props.serviceDiscovery);
    };
    const getDecoratorEndpointUrl = (props) => {
        const { params, csr } = props;
        const baseUrl = getDecoratorBaseUrl(props);
        return `${baseUrl}/${csr ? "csr" : "ssr"}${objectToQueryString(params)}`;
    };

    const getCsrElements = (csrProps) => {
        const props = Object.assign(Object.assign({}, csrProps), { csr: true });
        const envUrl = getDecoratorEndpointUrl(props);
        const assetsUrl = getDecoratorEndpointUrl(Object.assign(Object.assign({}, props), { params: undefined }));
        const scriptSrc = `${assetsUrl}/client.js`;
        return {
            header: '<div id="decorator-header"></div>',
            footer: '<div id="decorator-footer"></div>',
            env: `<div id="decorator-env" data-src="${envUrl}"></div>`,
            styles: `<link href="${assetsUrl}/css/client.css" rel="stylesheet" />`,
            scripts: `<script src="${scriptSrc}" defer></script>`,
            scriptSrc,
        };
    };

    const injectDecoratorClientSide = (csrProps) => __awaiter(void 0, void 0, void 0, function* () {
        const { env, header, scriptSrc, styles, footer } = getCsrElements(csrProps);
        document.head.insertAdjacentHTML("beforeend", styles);
        document.head.insertAdjacentHTML("beforeend", env);
        document.body.insertAdjacentHTML("afterbegin", header);
        document.body.insertAdjacentHTML("beforeend", footer);
        const script = document.createElement("script");
        script.async = true;
        script.src = scriptSrc;
        document.body.appendChild(script);
    });

    const chatbotButtonId = "chatbot-frida-knapp";
    const openChatbot = () => {
        setParams({ chatbotVisible: true }).then(() => {
            const chatButton = document.getElementById(chatbotButtonId);
            if (!(chatButton === null || chatButton === void 0 ? void 0 : chatButton.click)) {
                console.warn("Chatbot button element does not exist on the page");
                return;
            }
            chatButton.click();
        });
    };

    const DECORATOR_DATA_TIMEOUT = 5000;
    const defaultConsentObject = {
        consent: {
            analytics: false,
            surveys: false,
        },
        userActionTaken: false,
        meta: {
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            version: 1,
        },
    };
    const awaitNavWebStorage = () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
                reject(new Error(`Timed out after ${DECORATOR_DATA_TIMEOUT}ms waiting for __DECORATOR_DATA__ to be set. Please check that the decorator is infact loading.`));
            }, DECORATOR_DATA_TIMEOUT);
            const checkForDecoratorData = () => {
                if (window.__DECORATOR_DATA__ && window.webStorageController) {
                    clearTimeout(timeout);
                    resolve(true);
                }
                else {
                    setTimeout(checkForDecoratorData, 50);
                }
            };
            checkForDecoratorData();
        });
    });
    const isStorageKeyAllowed = (key) => {
        var _a;
        return (_a = window.webStorageController) === null || _a === void 0 ? void 0 : _a.isStorageKeyAllowed(key);
    };
    const getAllowedStorage = () => {
        var _a;
        return (_a = window.webStorageController) === null || _a === void 0 ? void 0 : _a.getAllowedStorage();
    };
    const getCurrentConsent = () => {
        var _a, _b;
        return (_b = (_a = window.webStorageController) === null || _a === void 0 ? void 0 : _a.getCurrentConsent()) !== null && _b !== void 0 ? _b : defaultConsentObject;
    };

    // Cookies
    // ------------------------------
    const setNavCookie = (name, value, options) => {
        if (!isStorageKeyAllowed(name)) {
            console.warn(`The key ${name} is not in the allow list or user has not given consent.`);
            return null;
        }
        return Cookies.set(name, value, options);
    };
    const getNavCookie = (name) => {
        if (!isStorageKeyAllowed(name)) {
            console.warn(`The key ${name} is not in the allow list or user has not given consent.`);
            return null;
        }
        return Cookies.get(name);
    };
    const createStorage = (storage) => ({
        getItem(key) {
            if (!isStorageKeyAllowed(key)) {
                console.warn(`The key ${key} is not in the allow list or user has not given consent.`);
                return null;
            }
            return storage.getItem(key);
        },
        setItem(key, value) {
            if (!isStorageKeyAllowed(key)) {
                console.warn(`The key ${key} is not in the allow list or user has not given consent.`);
                return null;
            }
            storage.setItem(key, value);
            return value;
        },
        removeItem(key) {
            if (!isStorageKeyAllowed(key)) {
                console.warn(`The key ${key} is not in the allow list or user has not given consent.`);
                return null;
            }
            storage.removeItem(key);
        },
        clear() {
            storage.clear();
        },
        key(index) {
            return storage.key(index);
        },
        get length() {
            return storage.length;
        },
    });
    const createLocalStorage = () => {
        if (typeof window === "undefined") {
            return null;
        }
        return createStorage(window.localStorage);
    };
    const createSessionStorage = () => {
        if (typeof window === "undefined") {
            return null;
        }
        return createStorage(window.sessionStorage);
    };
    // Creating augmented versions for sessionStorage and localStorage
    const navSessionStorage = createSessionStorage();
    const navLocalStorage = createLocalStorage();

    const waitForRetry$1 = () => __awaiter(void 0, void 0, void 0, function* () { return new Promise((resolve) => setTimeout(resolve, 500)); });
    const validateAmplitudeFunction = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (retries = 5) {
        if (typeof window.dekoratorenAmplitude === "function") {
            return Promise.resolve(true);
        }
        if (retries === 0) {
            return Promise.resolve(false);
        }
        yield waitForRetry$1();
        return validateAmplitudeFunction(retries - 1);
    });
    const silentLogger = () => {
        return Promise.resolve();
    };
    function logAmplitudeEvent(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof window === "undefined") {
                return Promise.reject("Amplitude is only available in the browser");
            }
            if (!window.dekoratorenAmplitude) {
                return silentLogger;
            }
            const isValid = yield validateAmplitudeFunction();
            if (!isValid) {
                return Promise.reject("Amplitude instance not found, it may not have been initialized yet");
            }
            return window.dekoratorenAmplitude(params);
        });
    }
    function getAmplitudeInstance(origin) {
        return (
        // Can be set to never if we want to be more strict
        eventName, eventData) => {
            return logAmplitudeEvent({
                eventName,
                eventData,
                origin,
            });
        };
    }

    const waitForRetry = () => __awaiter(void 0, void 0, void 0, function* () { return new Promise((resolve) => setTimeout(resolve, 500)); });
    const validateAnalyticsFunction = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (retries = 5) {
        if (typeof window.dekoratorenAnalytics === "function") {
            return Promise.resolve(true);
        }
        if (retries === 0) {
            return Promise.resolve(false);
        }
        yield waitForRetry();
        return validateAnalyticsFunction(retries - 1);
    });
    function logAnalyticsEvent(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof window === "undefined") {
                return Promise.reject("Analytics is only available in the browser");
            }
            const isValid = yield validateAnalyticsFunction();
            if (!isValid) {
                return Promise.reject("Analytics instance not found, it may not have been initialized yet");
            }
            return window.dekoratorenAnalytics(params);
        });
    }
    function getAnalyticsInstance(origin) {
        return (
        // Can be set to never if we want to be more strict
        eventName, eventData) => {
            return logAnalyticsEvent({
                eventName,
                eventData,
                origin,
            });
        };
    }

    exports.awaitDecoratorData = awaitNavWebStorage;
    exports.getAllowedStorage = getAllowedStorage;
    exports.getAmplitudeInstance = getAmplitudeInstance;
    exports.getAnalyticsInstance = getAnalyticsInstance;
    exports.getCurrentConsent = getCurrentConsent;
    exports.getNavCookie = getNavCookie;
    exports.getParams = getParams;
    exports.injectDecoratorClientSide = injectDecoratorClientSide;
    exports.isStorageKeyAllowed = isStorageKeyAllowed;
    exports.logAmplitudeEvent = logAmplitudeEvent;
    exports.logAnalyticsEvent = logAnalyticsEvent;
    exports.navLocalStorage = navLocalStorage;
    exports.navSessionStorage = navSessionStorage;
    exports.onBreadcrumbClick = onBreadcrumbClick;
    exports.onLanguageSelect = onLanguageSelect;
    exports.openChatbot = openChatbot;
    exports.setAvailableLanguages = setAvailableLanguages;
    exports.setBreadcrumbs = setBreadcrumbs;
    exports.setNavCookie = setNavCookie;
    exports.setParams = setParams;

}));
//# sourceMappingURL=index.js.map
